import { takeLatest, fork, all } from 'redux-saga/effects';
import menuSaga from './menuSaga';
import authSaga from './authSaga';

function* rootSaga() {
  yield all([authSaga(), menuSaga()]);
}
export default rootSaga;
